export const categoryTeams = {
  "Men's Beginners Doubles": [],
  "Women's Doubles (Intermediate)": [],
  "Mixed Doubles (Advance)": [],
  "Men's Split Age 30+ Doubles (Intermediate)": [],
  "Men's Doubles (Intermediate)": [],
  "Men's Split Age 30+ Doubles (Advance)": [],
  "Men's Doubles (Advance)": [],
};

// Helper function to get teams for a specific category
export const getTeamsByCategory = (category) => {
  return categoryTeams[category] || [];
};

// Helper function to get all available categories
export const getAllCategories = () => {
  return Object.keys(categoryTeams);
};

// Helper function to check if a category exists
export const categoryExists = (category) => {
  return categoryTeams.hasOwnProperty(category);
};
